import {expenseConstants} from '../constants';

const expenseState = {
  agentChatProps: { open: false },
  expense: {},
};

const expenseReducer = (state = expenseState, action) => {
  const {type, data} = action;
  switch (type) {
    case expenseConstants.GET_EXPENSE:
      return {
        ...state,
        expense: data
      }
    case expenseConstants.CLOSE_EXPENSE_AGENT_CHAT:
      return {
        ...state,
        agentChatProps: { open: false }
      }
    case expenseConstants.OPEN_EXPENSE_AGENT_CHAT:
      return {
        ...state,
        agentChatProps: { open: true, ...data }
      }
    default:
      return state;
  }
};

export default expenseReducer;
